import { Component } from 'react';
import { FaWhatsapp } from "react-icons/fa";
import { FaPencilAlt } from "react-icons/fa";
import { FaUserGraduate } from "react-icons/fa6";
import { FaChartLine } from "react-icons/fa6";
import { FaPlaneDeparture } from "react-icons/fa6";

class Banner extends Component {
    
    render() {
        return (
        <section className="banner-style-4 banner-padding">
            <div className="container">
                <div className="row align-items-center justify-content-center">
                    <div className="col-md-12 col-lg-6 col-xl-7">
                        <div className="banner-content ">
                            <span className="subheading">Online and Offline Course Available</span>
                            <h1>
                              <ul>
                                <li>Unlock Your Future Abroad</li>
                                <li>with Confident English Skills</li>
                              </ul>
                               </h1>
                            <p className="mb-40"> 
                              Dari basic English hingga siap IELTS/TOEFL, kami bantu kamu tembus kampus luar negeri dengan lebih percaya diri & terarah.
                            </p>

                            <div className="btn-container d-flex flex-wrap justify-content-center justify-content-md-start gap-3">
                                <a href="https://wa.me/6281238431234" target="_blank" rel="noreferrer" className="btn btn-main rounded d-flex align-items-center gap-1"><FaWhatsapp/> Mulai Konsultasi Gratis</a>
                                <a href="https://placement-test.niecindonesia.com/" target="_blank" rel="noreferrer" className="btn btn-main rounded d-flex align-items-center gap-1"><FaPencilAlt/> Cek Level Inggris Kamu</a>
                                {/* <Link to="#" className="btn btn-white rounded ms-2">Get started </Link> */}
                            </div>

                            <div className="mt-4 text-white">
                                <ul>
                                    <li><FaUserGraduate className='me-2'/> 1000+ Students berhasil improve English mereka</li>
                                    <li><FaChartLine className='me-2'/> Rata-rata peningkatan score hingga +1 band IELTS</li>
                                    <li><FaPlaneDeparture className='me-2'/> Alumni kami berhasil study abroad ke berbagai negara</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-12 col-lg-6 col-xl-5">
                        <div className="banner-img-round mt-5 mt-lg-0">
                            <img src="assets/images/banner/model-ec.png" alt="student-banner-model" className="img-fluid banner-model"/>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        );
    }
}

export default Banner;

